import { useContext } from 'react'
import Loader from '../Loader'
import { Link } from 'react-router'
import { ROUTE } from '../../cnst/router.cnst'
import LinkButton from '../LinkButton'
import { useTr } from '../../utils/useTr'
import { TrKey } from '../../cnst/translations/trKey.cnst'
import CmsEditor from './CmsEditor'
import { CmsEditorContext } from '../../contexts/CmsEditor.context'
import { LucideIconName } from '@bm-js/atlascloud-shared'

const CmsEditorWrapper = () => {
  const { tr } = useTr()
  const { editorData, status } = useContext(CmsEditorContext)

  if (status.isLoading)
    return (
      <div className='flex items-center justify-center h-screen'>
        <Loader />
      </div>
    )

  if (status.isError || !editorData)
    return (
      <div className='items-center justify-center flex-col flex h-screen text-center'>
        <p className='text-primary-400 text-2xl font-bold mb-4'>
          {tr(TrKey.somethingWentWrong)}
        </p>
        <Link to={ROUTE.DASHBOARD}>
          <LinkButton icon={LucideIconName.SquareArrowLeft}>
            {tr(TrKey.editorBackToOverview)}
          </LinkButton>
        </Link>
      </div>
    )

  return <CmsEditor />
}

export default CmsEditorWrapper
